import { IComponentOptions } from "angular";
import { WebJobsController } from './controller';

export const vsComponentName = 'webJobsComponent';

export const webJobsComponentOptions: IComponentOptions = {
  controller: WebJobsController,
  template: require('!html-loader!./index.html').default,
  controllerAs: 'stateController',
  bindings: {
    webJobs: "<",
    onAddNew: "<"
  },
};